import CreditCardSwitch, { NEW_CREDIT_CARD_OPTION_VALUE } from './CreditCardSwitch';

export default CreditCardSwitch;
export { NEW_CREDIT_CARD_OPTION_VALUE };
